import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import { useAnalytics } from '@/hooks/analytics';

import { heroMessages, sharedMessages } from '../messages';
import { Detail, GridWrapper, HeroSection, LimitedTimeCallout, Title } from './styles';

const Hero = () => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();

	const logClickCTA = () => {
		logEvent({
			eventName: 'Page : CTA_top : Clicked',
			eventProps: {
				type: 'button',
				copy: formatMessage(sharedMessages.sharedCta),
			},
		});
	};

	return (
		<HeroSection>
			<GridWrapper>
				<div>
					<LimitedTimeCallout color="white">
						{formatMessage(sharedMessages.sharedSpecialLabel)}
					</LimitedTimeCallout>
					<Title>{formatMessage(heroMessages.heroHeadline)}</Title>
					<Detail>{formatMessage(heroMessages.heroDetail)}</Detail>
					<Button
						href="/signup-flow?source=second_free_trial_offer&focus=second_free_trial"
						backgroundColor="white"
						focusRingVariant="light"
						textColor="text"
						onPress={logClickCTA}
					>
						{formatMessage(sharedMessages.sharedCta)}
					</Button>
				</div>
			</GridWrapper>
		</HeroSection>
	);
};

export default Hero;
